import { Main } from '@/components/layout/main'
import { ContactsDialogs } from './components/contact-dialogs'
import { ContactsPrimaryButtons } from './components/contacts-primary-buttons'
import { ContactsDataTable } from './components/data-table'
import ContactsProvider from './context/contacts-context'

export default function Contacts() {
  return (
    <ContactsProvider>
      <Main>
        <div className='flex flex-wrap items-center justify-between mb-2 space-y-2 gap-x-4'>
          <div>
            <h2 className='text-2xl font-bold tracking-tight'>Contatos</h2>
            <p className='text-muted-foreground'>
              Aqui você gerencia os contatos cadastrados.
            </p>
          </div>
          <ContactsPrimaryButtons />
        </div>
        <div className='flex-1 px-4 py-1 -mx-4 overflow-auto lg:flex-row lg:space-x-12 lg:space-y-0'>
          <ContactsDataTable />
        </div>
      </Main>

      <ContactsDialogs />
    </ContactsProvider>
  )
}
